export default "__VITE_ASSET__DgrN53w4__"